import { useCallback, useSyncExternalStore } from 'react';
import { gravarPreferencia, lerPreferencia } from './preferencias';

/** Tema escolhido pela pessoa; "sistema" segue o sistema operacional (CA-01). */
export type Tema = 'claro' | 'escuro' | 'sistema';

const CONSULTA_ESCURO = '(prefers-color-scheme: dark)';
const ouvintes = new Set<() => void>();

function sistemaEscuro(): boolean {
  return typeof window.matchMedia === 'function' && window.matchMedia(CONSULTA_ESCURO).matches;
}

export function lerTema(): Tema {
  const salvo = lerPreferencia('tema');
  return salvo === 'claro' || salvo === 'escuro' ? salvo : 'sistema';
}

/** Põe ou tira a classe `.dark` no <html>. Chamado no `main.tsx` antes do primeiro desenho. */
export function aplicarTema(tema: Tema = lerTema()): void {
  const escuro = tema === 'escuro' || (tema === 'sistema' && sistemaEscuro());
  document.documentElement.classList.toggle('dark', escuro);
}

export function definirTema(tema: Tema): void {
  gravarPreferencia('tema', tema);
  aplicarTema(tema);
  ouvintes.forEach((ouvinte) => {
    ouvinte();
  });
}

function assinar(ouvinte: () => void) {
  ouvintes.add(ouvinte);
  const midia = typeof window.matchMedia === 'function' ? window.matchMedia(CONSULTA_ESCURO) : null;
  const aoMudarSistema = () => {
    if (lerTema() === 'sistema') aplicarTema('sistema');
  };
  midia?.addEventListener('change', aoMudarSistema);
  return () => {
    ouvintes.delete(ouvinte);
    midia?.removeEventListener('change', aoMudarSistema);
  };
}

export function useTema(): [Tema, (tema: Tema) => void] {
  const tema = useSyncExternalStore(assinar, lerTema);
  return [
    tema,
    useCallback((novo: Tema) => {
      definirTema(novo);
    }, []),
  ];
}
